<div class="auth-wrapper auth-v2">
  <!-- Brand logo (HORS de la .row) -->
  <a class="brand-logo" href="javascript:void(0);">
    <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />
    <h2 class="brand-text text-primary ml-1">Vuexy</h2>
  </a>
  <!-- /Brand logo -->

  <div class="auth-inner row m-0">
    <!-- Left Image -->
    <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
      <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
        <img
          class="img-fluid"
          [src]="
            coreConfig.layout.skin === 'dark'
              ? 'assets/images/pages/login-v2-dark.svg'
              : 'assets/images/pages/login-v2.svg'
          "
          alt="Code de vérification"
        />
      </div>
    </div>

    <!-- Verification Form -->
    <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
      <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
        <h2 class="card-title font-weight-bold mb-1">Vérification de l’email</h2>
        <p class="card-text mb-2">
          Un code de vérification vous a été envoyé par email. Veuillez le saisir ci-dessous pour continuer.
        </p>

        <div class="form-group">
          <label class="form-label" for="register-token">Code de vérification</label>
          <input
            type="text"
            id="register-token"
            class="form-control"
            placeholder="Ex. 123456"
            tabindex="1"
            [(ngModel)]="data.token"
            [class.border-red]="dataError.token && dataError.token.length > 0"
            required
          />
          <div class="alert-body red" *ngIf="dataError.token && dataError.token.length > 0">
            <p>{{ dataError.token }}</p>
          </div>
        </div>

        <button
          [disabled]="loading"
          class="btn btn-primary btn-block"
          tabindex="2"
          (click)="tokenVerif()"
          rippleEffect
        >
          <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
          Vérifier
        </button>

       <p class="text-center mt-2">
            <span>Vous n'avez pas reçu le code ?</span>

                    <a href="javascript:void(0);" (click)="resendCode()" [class.text-muted]="!canResend" [style.pointerEvents]="canResend ? 'auto' : 'none'">
                        <span *ngIf="canResend">&nbsp;Renvoyer</span>
                        <span *ngIf="!canResend">&nbsp;Renvoyer ({{ countdown }}s)</span>
                    </a>
        </p>
      </div>
    </div>
    <!-- /Verification Form -->
  </div>
</div>
